import * as yup from "yup";
import { ValidationError } from "yup";
import { BusinessType } from "../MoneyTransfer/BusinessType.tsx";
import {
  isForeignBillingCountry,
  ItalianBillingCountry,
} from "../MoneyTransfer/billingCountries.ts";

const BILLING_COUNTRY = "address.country";

export const bonificoBillingSchemaFields = {
  invoiceRequired: yup.boolean().default(true),
  businessType: yup
    .string()
    .required("Tipo entità richiesto")
    .test("known-business-type", "Tipo entità richiesto", (value) =>
      [
        BusinessType.Person,
        BusinessType.IndividualCompany,
        BusinessType.Company,
      ].includes(value as BusinessType),
    ),
  businessName: yup.string().when("businessType", {
    is: BusinessType.Company,
    then: (s) => s.required("Ragione sociale richiesta per le aziende"),
    otherwise: (s) => s.notRequired(),
  }),
  vat: yup
    .string()
    .when([BILLING_COUNTRY, "businessType"], ([country, businessType], s) => {
      if (isForeignBillingCountry(country))
        return s.required("Tax ID richiesto per i clienti esteri");
      return businessType !== BusinessType.Person
        ? s.required("Partita IVA richiesta")
        : s.notRequired();
    }),
  taxCode: yup
    .string()
    .trim()
    .when(BILLING_COUNTRY, {
      is: isForeignBillingCountry,
      then: (s) => s.notRequired(),
      otherwise: (s) => s.required("Codice fiscale richiesto"),
    }),
  address: yup.object({
    country: yup.string().default(ItalianBillingCountry.Italy),
    street: yup.string().required("Indirizzo richiesto"),
    cap: yup.string().when("country", {
      is: isForeignBillingCountry,
      then: (s) => s.notRequired(),
      otherwise: (s) =>
        s
          .required("Codice postale richiesto")
          .matches(/^\d{5}$/, "Codice postale non valido"),
    }),
    city: yup.string().required("Città richiesta"),
    province: yup.string().when("country", {
      is: isForeignBillingCountry,
      then: (s) => s.notRequired(),
      otherwise: (s) => s.required("Provincia richiesta"),
    }),
  }),
  pec: yup.string().email("PEC non valida").optional(),
  sdiCode: yup.string().optional(),
};

export function hasSdiOrPec(
  value: {
    businessType?: string;
    sdiCode?: string;
    pec?: string;
    address?: { country?: string };
  },
  context: yup.TestContext,
): boolean | ValidationError {
  if (value.businessType === BusinessType.Person) return true;
  if (isForeignBillingCountry(value.address?.country)) return true;
  if (value.sdiCode || value.pec) return true;
  const error = "Inserisci almeno un codice SDI o PEC";
  return context.createError({
    message: () => [
      new ValidationError(error, undefined, "sdiCode"),
      new ValidationError(error, undefined, "pec"),
    ],
  });
}
